import React from "react";
import {Dropdown} from "react-bootstrap";
import {Link, useNavigate} from "react-router-dom";
import {ROUTE_PATHS} from "Config/Router/Routes";
import {NavbarItem} from "Views/Shared/Navbar/NavbarItem";
import {NavbarDropdownItem} from "Views/Shared/Navbar/NavbarDropdownItem";
import {useIsDesktop} from "Hooks/Window/ResizeHook";
import {ToggleMenuMobileIcon} from "Views/Shared/Navbar/ToggleMenuMobileIcon";
import {UserService} from "../../../Services/User/UserService";
import {ADMIN_MENU} from "../../../Config/Menu/AdminMenu";
import {USER_MENU} from "../../../Config/Menu/UserMenu";

export const Menu: React.FC = () => {

    const isDesktop = useIsDesktop()
    const userService = new UserService()

    const renderMenu = (menu: any) => {
        return menu.map((item, index) => {
            if (item.children?.length > 0) {
                return (
                    <NavbarDropdownItem key={index} route={item.path} label={item.title}>
                        {item.children.map((child, childIndex) => (
                            <Dropdown.Item key={childIndex} href={child.path}>
                                {child.title}
                            </Dropdown.Item>
                        ))}
                    </NavbarDropdownItem>
                );
            } else {
                return (
                    <NavbarItem key={index} label={item.title} route={item.path} />
                );
            }
        });
    };

    return (
        <>
            {
                isDesktop && userService.isRegularUser() && renderMenu(USER_MENU)
            }
            {
                isDesktop && userService.isAdmin() && renderMenu(ADMIN_MENU)
            }

            <ToggleMenuMobileIcon/>

        </>
    )
}
